import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import persistThreadOpenedState from '@/redux/actions/pieveActions/threadMutations/persistThreadOpenedState.js';
import { routeThreadId } from '@/redux/selectors/pieveSelectors/routeSelectors.js';

/** Records that the person opened the conversation in the address, so its unread mark clears. */
const ThreadOpenedHandler = () => {
  const dispatch = useDispatch();
  const threadId = useSelector(routeThreadId);

  useEffect(() => {
    if (threadId) {
      dispatch(persistThreadOpenedState({ threadId, openedAt: new Date().toISOString() }));
    }
  }, [dispatch, threadId]);

  return null;
};

export default ThreadOpenedHandler;
